module.exports = __webpack_public_path__ + "assets/img/Ram-Group-Website.c982c1c3.jpg";